import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { getCountryName } from '@/utils/countryUtils';

interface CountryFlagProps {
  countryCode: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const CountryFlag: React.FC<CountryFlagProps> = ({ 
  countryCode, 
  size = 'md',
  className = '' 
}) => {
  if (!countryCode) return null;

  const sizeStyles = {
    sm: { width: '2em', height: '2em' },
    md: { width: '2.4em', height: '2.4em' },
    lg: { width: '3em', height: '3em' }
  };

  return (
    <ReactCountryFlag
      countryCode={countryCode}
      svg
      style={{
        ...sizeStyles[size],
        display: 'inline-block',
        verticalAlign: 'middle'
      }}
      title={getCountryName(countryCode)}
      className={`${className} align-middle`}
    />
  );
};

export default CountryFlag;